<template>
    <div class="component-wrap movie-swipe--wrap fx-row" @scroll="handleScroll" ref="movieSwipe">
        <div class="fx-row fx-end">
            <div class="cinema_movie-img--wrap" v-for="(item, index) in list" :key="index" ref="image" :style="`width: ${getImgWidth(activeIndex == index)}px`" :class="activeIndex == index ? 'active' : ''">
                <van-image :src="`${item.logo}`" @click="selectMovie(index)" width="100%" height="100%" radius="4" fit="cover"></van-image>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        input: Number,
        list: Array,
    },
    data() {
        return {
            activeIndex: 0,
            windowWidth: document.body.clientWidth,
            scrollSwitch: true,
        }
    },
    computed: {
        imgWidth() {
            return (document.body.clientWidth * 0.25);
        }
    },
    methods: {
        getImgWidth(activeFlag) {
            if (activeFlag) return (this.windowWidth * 0.28);
            else return (this.windowWidth * 0.25);
        },
        selectMovie(index) {
            this.$nextTick(() => {
                this.activeIndex = index;
                this.scrollToIndex(index);
            })
        },
        scrollToIndex(index) {
            let scrollLeft = index * this.imgWidth;
            let movieSwipe = this.$refs.movieSwipe;
            // let timer = null;
            this.scrollSwitch = false;
            movieSwipe.scrollTo(scrollLeft, 0);
            setTimeout(() => {
                this.scrollSwitch = true;
            }, 65)
        },

        handleScroll() {
            //节流滑动 0.1秒执行一次
            if (this.scrollSwitch) {
                this.$common.throttle(this.calcActiveIndex, 65);
                this.scrollSwitch = true;
            }
        },

        calcActiveIndex() {
            let images = this.$refs.image;
            let halfWindowWidth = parseInt(this.windowWidth / 2) - this.windowWidth * 0.28;
            let newImages = images.filter((item) => {
                return item.getBoundingClientRect().left >= halfWindowWidth;
            });
            // budo_log.info(`#63 当前还有${newImages.length}个的左侧距离大于屏幕一半${halfWindowWidth},所以当前activeIndex = ${images.length - newImages.length}`);
            this.activeIndex = images.length - newImages.length;
        },
    },
    watch: {
        activeIndex() {
            this.$emit('input', this.activeIndex);
        }
    }
}
</script>

<style lang="scss" scoped>
.movie-swipe--wrap::-webkit-scrollbar {
	display: none;
}
.movie-swipe--wrap {
	width: 100%;
	overflow-x: scroll;
    overflow-y: hidden;
	> div {
		height: 150px;
		margin: 0 calc(50% - 28% / 2);
		.cinema_movie-img--wrap {
			padding: 0 4px;
			height: 85%;
		}
		.cinema_movie-img--wrap.active {
			height: 100%;
		}
	}
}
</style>